/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierBatchLineAllocationDto } from './SupplierBatchLineAllocationDto';
import {
    SupplierBatchLineAllocationDtoFromJSON,
    SupplierBatchLineAllocationDtoFromJSONTyped,
    SupplierBatchLineAllocationDtoToJSON,
} from './SupplierBatchLineAllocationDto';

/**
 * 
 * @export
 * @interface SupplierBatchLineDto
 */
export interface SupplierBatchLineDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    batchId: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineDto
     */
    productName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineDto
     */
    productImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineDto
     */
    sku: string | null;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    requestedUnitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    requestedTotalQty: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    confirmedTotalQty: number | null;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineDto
     */
    confirmedUnitPrice: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierBatchLineDto
     */
    unavailable: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineDto
     */
    supplierNotes: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineDto
     */
    status: SupplierBatchLineDtoStatusEnum;
    /**
     * 
     * @type {Array<SupplierBatchLineAllocationDto>}
     * @memberof SupplierBatchLineDto
     */
    allocations: Array<SupplierBatchLineAllocationDto>;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchLineDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchLineDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const SupplierBatchLineDtoStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Modified: 'MODIFIED',
    Unavailable: 'UNAVAILABLE'
} as const;
export type SupplierBatchLineDtoStatusEnum = typeof SupplierBatchLineDtoStatusEnum[keyof typeof SupplierBatchLineDtoStatusEnum];


/**
 * Check if a given object implements the SupplierBatchLineDto interface.
 */
export function instanceOfSupplierBatchLineDto(value: object): value is SupplierBatchLineDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('batchId' in value) || value['batchId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productImageUrl' in value) || value['productImageUrl'] === undefined) return false;
    if (!('sku' in value) || value['sku'] === undefined) return false;
    if (!('requestedUnitPrice' in value) || value['requestedUnitPrice'] === undefined) return false;
    if (!('requestedTotalQty' in value) || value['requestedTotalQty'] === undefined) return false;
    if (!('confirmedTotalQty' in value) || value['confirmedTotalQty'] === undefined) return false;
    if (!('confirmedUnitPrice' in value) || value['confirmedUnitPrice'] === undefined) return false;
    if (!('unavailable' in value) || value['unavailable'] === undefined) return false;
    if (!('supplierNotes' in value) || value['supplierNotes'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('allocations' in value) || value['allocations'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupplierBatchLineDtoFromJSON(json: any): SupplierBatchLineDto {
    return SupplierBatchLineDtoFromJSONTyped(json, false);
}

export function SupplierBatchLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBatchLineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'batchId': json['batchId'],
        'productId': json['productId'],
        'productName': json['productName'],
        'productImageUrl': json['productImageUrl'],
        'sku': json['sku'],
        'requestedUnitPrice': json['requestedUnitPrice'],
        'requestedTotalQty': json['requestedTotalQty'],
        'confirmedTotalQty': json['confirmedTotalQty'],
        'confirmedUnitPrice': json['confirmedUnitPrice'],
        'unavailable': json['unavailable'],
        'supplierNotes': json['supplierNotes'],
        'status': json['status'],
        'allocations': ((json['allocations'] as Array<any>).map(SupplierBatchLineAllocationDtoFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SupplierBatchLineDtoToJSON(value?: SupplierBatchLineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'batchId': value['batchId'],
        'productId': value['productId'],
        'productName': value['productName'],
        'productImageUrl': value['productImageUrl'],
        'sku': value['sku'],
        'requestedUnitPrice': value['requestedUnitPrice'],
        'requestedTotalQty': value['requestedTotalQty'],
        'confirmedTotalQty': value['confirmedTotalQty'],
        'confirmedUnitPrice': value['confirmedUnitPrice'],
        'unavailable': value['unavailable'],
        'supplierNotes': value['supplierNotes'],
        'status': value['status'],
        'allocations': ((value['allocations'] as Array<any>).map(SupplierBatchLineAllocationDtoToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

